<script>

export default {
  data () {
    return {
      rmsTrendOption: {
        tooltip: {
          trigger: 'axis',
          formatter: function (params) {
            var tooltipTitleXAxis = ['-24:00', '-23:45', '-23:30', '-23:15', '-23:00', '-22:45', '-22:30', '-22:15', '-22:00', '-21:45', '-21:30', '-21:15', '-21:00', '-20:45', '-20:30', '-20:15', '-20:00', '-19:45', '-19:30', '-19:15', '-19:00', '-18:45', '-18:30', '-18:15', '-18:00', '-17:45', '-17:30', '-17:15', '-17:00', '-16:45', '-16:30', '-16:15', '-16:00', '-15:45', '-15:30', '-15:15', '-15:00', '-14:45', '-14:30', '-14:15', '-14:00', '-13:45', '-13:30', '-13:15', '-13:00', '-12:45', '-12:30', '-12:15', '-12:00', '-11:45', '-11:30', '-11:15', '-11:00', '-10:45', '-10:30', '-10:15', '-10:00', '-9:45', '-9:30', '-9:15', '-9:00', '-8:45', '-8:30', '-8:15', '-8:00', '-7:45', '-7:30', '-7:15', '-7:00', '-6:45', '-6:30', '-6:15', '-6:00', '-5:45', '-5:30', '-5:15', '-5:00', '-4:45', '-4:30', '-4:15', '-4:00', '-3:45', '-3:30', '-3:15', '-3:00', '-2:45', '-2:30', '-2:15', '-2:00', '-1:45', '-1:30', '-1:15', '-1:00', '-0:45', '-0:30', '-0:15', '-0:00']
            var relIndex = params[0].dataIndex
            var relVal = tooltipTitleXAxis[relIndex]
            for (var i = 0, l = params.length; i < l; i++) {
              relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'V'
            }
            return relVal
          }
        },
        grid: {
          x1: 10,
          y2: 40,
          x2: 30
        },
        legend: {
          data: ['A相', 'B相', 'C相'],
          // right: 30,
          top: 20,
          formatter: ''
        },
        toolbox: {
          show: true,
          feature: {}
        },
        calculable: true,
        xAxis: [{
          type: 'category',
          name: 'h',
          data: ['-24', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-20', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-16', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-12', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-8', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '-4', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '', '0']
        }],
        yAxis: [{
          type: 'value',
          name: 'V',
          axisLabel: {
            // formatter: '{value} %'
          }
        }],
        series: [{
          name: 'A相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#fccc00'
          },
          data: [0.00, 5.00, 0.00, 6.00, 0.00, 9.00, 0.00]
        }, {
          name: 'B相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#009800'
          },
          data: [7.00, 4.00, 6.00, 1.00, 5.00, 8.00, 3.00]
        }, {
          name: 'C相',
          type: 'line',
          showSymbol: false,
          itemStyle: {
            color: '#ff0000'
          },
          data: [4.00, 5.00, 2.00, 1.00, 8.00, 5.00, 3.00]
        }]
      },
      rmsTrendChart: {},
      // 电气量下拉框
      rmsSelectOptions: [{
        value: 1,
        label: 'Ua'
      }, {
        value: 2,
        label: 'Ub'
      }, {
        value: 3,
        label: 'Uc'
      }, {
        value: 4,
        label: 'Ia'
      }, {
        value: 5,
        label: 'Ib'
      }, {
        value: 6,
        label: 'Ic'
      }],
      rmsSelectValue: 1,
      interval: null,
      lastTs: 0
    }
  },
  mounted () {
    this.rmsTrendChart = this.$echarts.init(document.getElementById('rmsTrendChartOptions'))
    // this.rmsTrendChart.setOption(this.rmsTrendOption)
    this.updateData()
    if (!this.interval) {
      this.interval = setInterval(() => {
        this.$api.getTs({
          collection: 'meter_stable_data',
          sn: this.$store.state.sn
        }).then((res) => {
          if (this.lastTs !== res.data.data.ts) {
            this.lastTs = res.data.data.ts
            this.updateData()
          }
          // else if (new Date().getTime() - res.data.data.ts > 900000) {
          //   if (this.interval) {
          //     clearInterval(this.interval)
          //     this.interval = null
          //   }
          //   this.timeOver = true
          // }
        })
      }, 1000)
    }
  },
  destroyed () {
    if (this.interval) {
      clearInterval(this.interval)
      this.interval = null
    }
  },
  methods: {
    async updateData () {
      var max = 0
      var min = 0x7fffffff
      var tableData = {
        a: [],
        b: [],
        c: []
      }
      let params = {
        'collection': 'meter_stable_data',
        'sn': this.$store.state.sn ? this.$store.state.sn : window.localStorage.getItem('sn'),
        'num': 97,
        'fields': ['ua_rms', 'ub_rms', 'uc_rms'],
        'transpose': true
      }
      const {data: res} = await this.$api.queryLastDatas(params)
      if (res.code !== 0) {
        this.$message.error(res.msg)
        return
      }
      for (let i = 0; i < res.data.ua_rms.length; i++) {
        if (max < res.data.ua_rms[i]) max = res.data.ua_rms[i]
        if (max < res.data.ub_rms[i]) max = res.data.ub_rms[i]
        if (max < res.data.uc_rms[i]) max = res.data.uc_rms[i]
        if (min > res.data.ua_rms[i]) min = res.data.ua_rms[i]
        if (min > res.data.ub_rms[i]) min = res.data.ub_rms[i]
        if (min > res.data.uc_rms[i]) min = res.data.uc_rms[i]
      }
      if (max > 1000 || min < -1000) {
        for (let i = 0; i < res.data.ua_rms.length; i++) {
          tableData.a[i] = res.data.ua_rms[i] * 0.001
          tableData.b[i] = res.data.ub_rms[i] * 0.001
          tableData.c[i] = res.data.uc_rms[i] * 0.001
        }
        this.rmsTrendOption.yAxis[0].name = 'kV'
        this.rmsTrendOption.tooltip.formatter = function (params) {
          var tooltipTitleXAxis = ['-24:00', '-23:45', '-23:30', '-23:15', '-23:00', '-22:45', '-22:30', '-22:15', '-22:00', '-21:45', '-21:30', '-21:15', '-21:00', '-20:45', '-20:30', '-20:15', '-20:00', '-19:45', '-19:30', '-19:15', '-19:00', '-18:45', '-18:30', '-18:15', '-18:00', '-17:45', '-17:30', '-17:15', '-17:00', '-16:45', '-16:30', '-16:15', '-16:00', '-15:45', '-15:30', '-15:15', '-15:00', '-14:45', '-14:30', '-14:15', '-14:00', '-13:45', '-13:30', '-13:15', '-13:00', '-12:45', '-12:30', '-12:15', '-12:00', '-11:45', '-11:30', '-11:15', '-11:00', '-10:45', '-10:30', '-10:15', '-10:00', '-9:45', '-9:30', '-9:15', '-9:00', '-8:45', '-8:30', '-8:15', '-8:00', '-7:45', '-7:30', '-7:15', '-7:00', '-6:45', '-6:30', '-6:15', '-6:00', '-5:45', '-5:30', '-5:15', '-5:00', '-4:45', '-4:30', '-4:15', '-4:00', '-3:45', '-3:30', '-3:15', '-3:00', '-2:45', '-2:30', '-2:15', '-2:00', '-1:45', '-1:30', '-1:15', '-1:00', '-0:45', '-0:30', '-0:15', '-0:00']
          var relIndex = params[0].dataIndex
          var relVal = tooltipTitleXAxis[relIndex]
          for (var i = 0, l = params.length; i < l; i++) {
            relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'kV'
          }
          return relVal
        }
      } else {
        tableData.a = res.data.ua_rms
        tableData.b = res.data.ub_rms
        tableData.c = res.data.uc_rms

        this.rmsTrendOption.yAxis[0].name = 'V'
        this.rmsTrendOption.tooltip.formatter = function (params) {
          var tooltipTitleXAxis = ['-24:00', '-23:45', '-23:30', '-23:15', '-23:00', '-22:45', '-22:30', '-22:15', '-22:00', '-21:45', '-21:30', '-21:15', '-21:00', '-20:45', '-20:30', '-20:15', '-20:00', '-19:45', '-19:30', '-19:15', '-19:00', '-18:45', '-18:30', '-18:15', '-18:00', '-17:45', '-17:30', '-17:15', '-17:00', '-16:45', '-16:30', '-16:15', '-16:00', '-15:45', '-15:30', '-15:15', '-15:00', '-14:45', '-14:30', '-14:15', '-14:00', '-13:45', '-13:30', '-13:15', '-13:00', '-12:45', '-12:30', '-12:15', '-12:00', '-11:45', '-11:30', '-11:15', '-11:00', '-10:45', '-10:30', '-10:15', '-10:00', '-9:45', '-9:30', '-9:15', '-9:00', '-8:45', '-8:30', '-8:15', '-8:00', '-7:45', '-7:30', '-7:15', '-7:00', '-6:45', '-6:30', '-6:15', '-6:00', '-5:45', '-5:30', '-5:15', '-5:00', '-4:45', '-4:30', '-4:15', '-4:00', '-3:45', '-3:30', '-3:15', '-3:00', '-2:45', '-2:30', '-2:15', '-2:00', '-1:45', '-1:30', '-1:15', '-1:00', '-0:45', '-0:30', '-0:15', '-0:00']
          var relIndex = params[0].dataIndex
          var relVal = tooltipTitleXAxis[relIndex]
          for (var i = 0, l = params.length; i < l; i++) {
            relVal += '<br/>' + params[i].marker + params[i].seriesName + `&nbsp;&nbsp;&nbsp;&nbsp;` + params[i].value + 'V'
          }
          return relVal
        }
      }
      if (!res.data.ua_rms.length || res.data.ua_rms.length < 97) {
        var j = res.data.ua_rms.length ? res.data.ua_rms.length : 0
        for (var i = 0; i < (96 - j); i++) {
          tableData.a[j + i] = 0
          tableData.b[j + i] = 0
          tableData.c[j + i] = 0
        }
      }
      this.rmsTrendOption.series[0].data = tableData.a.reverse()
      this.rmsTrendOption.series[1].data = tableData.b.reverse()
      this.rmsTrendOption.series[2].data = tableData.c.reverse()
      // this.rmsTrendOption.clear()
      this.rmsTrendChart.setOption(this.rmsTrendOption)
      // console.log(data)
    }
  }
}
</script>

<template>
  <div class="pg">
    <div class="dataItems">
      <div class="title">24小时电压RMS值趋势图界面</div>
      <div style="height: calc(100% - 40px);">
        <div id="rmsTrendChartOptions" style="height: 100%; width: 100%"></div>
      </div>
    </div>
  </div>
</template>

<style scoped>
@import "../../../assets/css/stable.css";

.pg {
  height: calc(45vh - 50px);
}

.dataName {
  width: 15%;
}

.dataValue {
  width: 8%;
//border-right: 1px solid black;
}

.dataNvItem {
  height: calc((100% - 70px) / 11);
}
</style>



// WEBPACK FOOTER //
// src/pages/Trend/RmsTrend/RmsVTrend.vue